"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderControllerCancelOrder = exports.orderControllerCancelOrder = exports.useOrderControllerGetOrder = exports.getOrderControllerGetOrderQueryKey = exports.orderControllerGetOrder = exports.useOrderControllerGetMyOrders = exports.getOrderControllerGetMyOrdersQueryKey = exports.orderControllerGetMyOrders = exports.useOrderControllerDirectBuy = exports.orderControllerDirectBuy = exports.useOrderControllerCreateAsk = exports.orderControllerCreateAsk = exports.useOrderControllerCreateBid = exports.orderControllerCreateBid = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Exchange I-REC API
 * Swagger documentation for the Exchange I-REC API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const response_type_4 = __importDefault(require("../response-type"));
const response_type_5 = __importDefault(require("../response-type"));
const response_type_6 = __importDefault(require("../response-type"));
const orderControllerCreateBid = (createBidDTO) => {
    return (0, response_type_1.default)({ url: `/api/orders/bid`, method: 'post',
        data: createBidDTO
    });
};
exports.orderControllerCreateBid = orderControllerCreateBid;
const useOrderControllerCreateBid = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.orderControllerCreateBid)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrderControllerCreateBid = useOrderControllerCreateBid;
const orderControllerCreateAsk = (createAskDTO) => {
    return (0, response_type_2.default)({ url: `/api/orders/ask`, method: 'post',
        data: createAskDTO
    });
};
exports.orderControllerCreateAsk = orderControllerCreateAsk;
const useOrderControllerCreateAsk = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.orderControllerCreateAsk)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrderControllerCreateAsk = useOrderControllerCreateAsk;
const orderControllerDirectBuy = (directBuyDTO) => {
    return (0, response_type_3.default)({ url: `/api/orders/ask/buy`, method: 'post',
        data: directBuyDTO
    });
};
exports.orderControllerDirectBuy = orderControllerDirectBuy;
const useOrderControllerDirectBuy = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.orderControllerDirectBuy)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrderControllerDirectBuy = useOrderControllerDirectBuy;
const orderControllerGetMyOrders = () => {
    return (0, response_type_4.default)({ url: `/api/orders`, method: 'get'
    });
};
exports.orderControllerGetMyOrders = orderControllerGetMyOrders;
const getOrderControllerGetMyOrdersQueryKey = () => [`/api/orders`];
exports.getOrderControllerGetMyOrdersQueryKey = getOrderControllerGetMyOrdersQueryKey;
const useOrderControllerGetMyOrders = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrderControllerGetMyOrdersQueryKey)();
    const queryFn = () => (0, exports.orderControllerGetMyOrders)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useOrderControllerGetMyOrders = useOrderControllerGetMyOrders;
const orderControllerGetOrder = (id) => {
    return (0, response_type_5.default)({ url: `/api/orders/${id}`, method: 'get'
    });
};
exports.orderControllerGetOrder = orderControllerGetOrder;
const getOrderControllerGetOrderQueryKey = (id) => [`/api/orders/${id}`];
exports.getOrderControllerGetOrderQueryKey = getOrderControllerGetOrderQueryKey;
const useOrderControllerGetOrder = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrderControllerGetOrderQueryKey)(id);
    const queryFn = () => (0, exports.orderControllerGetOrder)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useOrderControllerGetOrder = useOrderControllerGetOrder;
const orderControllerCancelOrder = (id) => {
    return (0, response_type_6.default)({ url: `/api/orders/${id}/cancel`, method: 'post'
    });
};
exports.orderControllerCancelOrder = orderControllerCancelOrder;
const useOrderControllerCancelOrder = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id } = props || {};
        return (0, exports.orderControllerCancelOrder)(id);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrderControllerCancelOrder = useOrderControllerCancelOrder;
//# sourceMappingURL=orders.js.map